export default __webpack_public_path__ + "static/media/ScienceDept.a99e4fa1.png";